import { render, staticRenderFns } from "./BuyOnegetOne.vue?vue&type=template&id=835f4a7c&scoped=true"
import script from "./BuyOnegetOne.vue?vue&type=script&lang=js"
export * from "./BuyOnegetOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835f4a7c",
  null
  
)

export default component.exports